import { render, staticRenderFns } from "./Vendasvendedores.vue?vue&type=template&id=4f104f3e&"
import script from "./Vendasvendedores.vue?vue&type=script&lang=js&"
export * from "./Vendasvendedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports